import React from 'react';
import Home from './Home';
import Layout from '../../components/Layout';
import {
	organizationSchema,
	softwareApplicationSchema,
	webSiteSchema,
} from '../../utils/seo';

async function action() {
	return {
		title: 'New Tab Studio — Custom New Tab Page for Chrome',
		titleFull: true,
		description:
			'Replace the Chrome new tab page with your own: countdowns, clocks, to-do lists, habit trackers, notes and photos, dragged into place on any wallpaper. Free.',
		chunks: ['themes'],
		jsonLd: [
			organizationSchema(),
			webSiteSchema(),
			softwareApplicationSchema({ withRating: true }),
		],
		component: (
			<Layout>
				<Home />
			</Layout>
		),
	};
}

export default action;
